import useDisableBottomNavOnNewChallenge from 'components/BottomNavigation/useDisableBottomNavOnNewChallenge';
import config from 'config/common';

/**
 * Hook to determine if the main element's bottom margin should be disabled.
 * This is useful when the bottom navigation is hidden and we want to remove the space reserved for it.
 *
 * Current cases:
 * - New Challenges page with GuestIframe enabled
 *
 * @returns {boolean} True if the main bottom margin should be disabled
 */
const useDisableMainBottomMargin = (): boolean => {
    const isNewChallengePage = useDisableBottomNavOnNewChallenge();

    const isGuestIframeOnNewChallenge = isNewChallengePage && config.isGuestIframeOn;
    if (isGuestIframeOnNewChallenge) {
        return true;
    }

    return false;
};

export default useDisableMainBottomMargin;
